import { notifications } from "@mantine/notifications";

const formatFieldLabel = (key) =>
  key
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());

const parseErrorMessages = (data) => {
  if (!data) return [];

  if (typeof data === "string") {
    return [{ field: "Error", message: data }];
  }

  if (data.message && typeof data.message === "string") {
    return [{ field: "Error", message: data.message }];
  }

  if (data.detail) {
    return [{ field: "Error", message: String(data.detail) }];
  }

  return Object.entries(data).flatMap(([key, value]) => {
    if (Array.isArray(value)) {
      return value.map((message) => ({
        field: formatFieldLabel(key),
        message: String(message),
      }));
    }

    if (value && typeof value === "object") {
      return Object.entries(value).flatMap(([nestedKey, nestedValue]) => {
        if (Array.isArray(nestedValue)) {
          return nestedValue.map((message) => ({
            field: `${formatFieldLabel(key)} ${formatFieldLabel(nestedKey)}`,
            message: String(message),
          }));
        }

        return [
          {
            field: `${formatFieldLabel(key)} ${formatFieldLabel(nestedKey)}`,
            message: String(nestedValue),
          },
        ];
      });
    }

    return [{ field: formatFieldLabel(key), message: String(value) }];
  });
};

const errorNotifications = (data, error) => {
  const response = error?.response;

  if (!response) {
    notifications.show({
      title: "Error",
      message: error?.message || "An unknown error occurred. Please try again.",
      color: "red",
    });
    return;
  }

  const status = response.status;
  const statusText = response.statusText || "Error";
  const errorData = data ?? response.data;
  const messages = parseErrorMessages(errorData);

  if (status === 401) {
    notifications.show({
      title: "Unauthorized (401)",
      message:
        "You are not authorized to access this resource. Please log in.",
      color: "red",
    });
    return;
  }

  if (status === 404) {
    notifications.show({
      title: "Not Found (404)",
      message:
        messages[0]?.message ||
        "The requested resource could not be found.",
      color: "red",
    });
    return;
  }

  if (status === 500) {
    notifications.show({
      title: "Server Error (500)",
      message:
        messages[0]?.message ||
        "An internal server error occurred. Please try again later.",
      color: "red",
    });
    return;
  }

  if (!messages.length) {
    notifications.show({
      title: `${statusText} (${status})`,
      message: "Something went wrong. Please try again.",
      color: "red",
    });
    return;
  }

  messages.forEach(({ field, message }) => {
    notifications.show({
      title: `${statusText} (${status})`,
      message: `${field}: ${message}`,
      color: "red",
    });
  });
};

const successNotifications = (message) => {
  notifications.show({
    title: `${message}`,
  });
  return;
};

export { errorNotifications, successNotifications };
